import { IPlayer } from '@trackman/baseball-shared-components';
import { Button } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { FilterPosition, FilterStore } from 'stores/FilterStore';
import { SessionPlayStore } from 'stores/SessionPlayStore';
import { FilterSelect } from './FilterSelect';
import { ColumnList, ConfiguratorWrapper, StyledCloseIcon, Title } from './styles/FiltersStyles';

interface FiltersProps {}

const Filters: React.FC<FiltersProps> = observer(() => {
  const filterStore = useInjection<FilterStore>(ServiceTypes.FilterStore);
  const sessionPlayStore = useInjection<SessionPlayStore>(ServiceTypes.SessionPlayStore);

  const closeHandler = () => {
    filterStore.changeConfiguratorVisibility(false);
  };

  const playersToDropdownMap = (player: IPlayer) => ({
    label: `${player.firstName} ${player.lastName}`,
    value: player.id,
  });

  const players = useMemo(() => {
    console.log(sessionPlayStore.homeTeamRoster);
    console.log(filterStore.placeholderPlayers);

    return [...filterStore.placeholderPlayers, ...sessionPlayStore.homeTeamRoster, ...sessionPlayStore.awayTeamRoster].map(
      playersToDropdownMap
    );
  }, [sessionPlayStore.homeTeamRoster, sessionPlayStore.awayTeamRoster, filterStore.placeholderPlayers]);

  const clearFiltersHandler = () => {
    filterStore.clearFilters();
  };

  return filterStore.isConfiguratorVisible ? (
    <ConfiguratorWrapper>
      <Title>
        Filters
        <StyledCloseIcon data-testid='filter-close-button' onClick={closeHandler} />
      </Title>
      <ColumnList>
        <FilterSelect position={FilterPosition.Pitcher} players={players} />
        <FilterSelect position={FilterPosition.Catcher} players={players} />
        <FilterSelect position={FilterPosition.Batter} players={players} />
        <Button
          intent='tertiary'
          onClick={clearFiltersHandler}
          label='Clear all'
          width={'fit-content'}
          data-testid='clear-filters-button'
          disabled={filterStore.countFilters() === 0}
        />
      </ColumnList>
    </ConfiguratorWrapper>
  ) : null;
});

export default Filters;
